module.exports = __webpack_public_path__ + "static/img/cover_tips_4.a1788a2a.png";